export Button from './Button/Button';



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/components/index.js